import { api } from "~/utils/api"

export const useGetTrimVariantMetrics = (
  collectionIds: number[],
  compareCollectionIds: number[] | null,
  enabled: boolean = true,
) => {
  return api.pythonApi.getTrimVariantMetrics.useQuery(
    { collectionIds, compareCollectionIds },
    {
      enabled: collectionIds.length > 0 && enabled,
    },
  )
}

export const useGetDemandVariantMetrics = (
  collectionIds: number[],
  compareCollectionIds: number[] | null,
  enabled: boolean = true,
) => {
  return api.pythonApi.getDemandVariantMetrics.useQuery(
    { collectionIds, compareCollectionIds },
    {
      enabled: collectionIds.length > 0 && enabled,
    },
  )
}

export const useGetHistoricCollectionSeasonality = (collectionIdsList: number[][]) => {
  return api.pythonApi.getHistoricCollectionSeasonality.useQuery({ collectionIdsList })
}
